/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Subject } from "rxjs";
import { API_PATH } from "src/environments/config";
// import { Product } from '../models/product-home-interface';
import {
  ProductRequestToGetReviews,
  ReveiwDetails,
  ReviewLikeDislikeRequest,
} from "../../models/review.interface";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};
const userEmailCheck: RegExp = /^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
const userPhoneCheck: RegExp = /^[0-9]{10}$/;

@Injectable({
  providedIn: "root",
})
export class ReviewService {
  constructor(private http: HttpClient, private router: Router) {}

  uploadReviewImageSubject: Subject<any> = new Subject();
  uploadProfileImageSubject: Subject<any> = new Subject();
  homeToRatingIdSend: BehaviorSubject<any> = new BehaviorSubject({});
  likeSubject: BehaviorSubject<any> = new BehaviorSubject({});
  diLikeSubject: BehaviorSubject<any> = new BehaviorSubject({});
  isSubmited: BehaviorSubject<boolean> = new BehaviorSubject(false);

  reviewToSendStars: BehaviorSubject<any> = new BehaviorSubject({});
  // ratingInHomePage: BehaviorSubject<any>=new BehaviorSubject({});
  saveReview(reviewDetails: any) {
    console.log(reviewDetails);
    // if (this.cookieService.check('SESSIONID')) {
    // const sessionId: string = this.cookieService.get('SESSIONID');
    // console.log(sessionId);
    // httpOptions.headers = httpOptions.headers.set('Authorization', sessionId);
    return this.http.post<any>(`${API_PATH.apis.saveReview}`, reviewDetails);
    // }
  }

  handleReviewLikeDislike(reviewLikeDislikeRequest: ReviewLikeDislikeRequest) {
    return this.http.post<any>(
      `${API_PATH.apis.saveReview}`,
      reviewLikeDislikeRequest,
      httpOptions
    );
  }
  fetchReviewsForUser(page?: any) {
    // const sessionId: string = this.cookieService.get('SESSIONID');
    // httpOptions.headers = httpOptions.headers.set('Authorization', sessionId);
    let params = new HttpParams();
    params = page ? params.set("page", page) : params;
    return this.http.get<any>(`${API_PATH.apis.userReviews}`, {
      params: params,
    });
  }

  getReviewDetails(requestDataObject?: any, page?: any) {
    // const sessionId: string = this.cookieService.get('SESSIONID');
    //  httpOptions.headers = httpOptions.headers.set('Authorization', sessionId);
    let params = new HttpParams();
    params = page ? params.set("page", page) : params;
    params = requestDataObject.itemMasterGroupId
      ? params.set("itemMasterGroupId", requestDataObject.itemMasterGroupId)
      : params;
    params = requestDataObject.inventoryGroupId
      ? params.set("inventoryGroupId", requestDataObject.inventoryGroupId)
      : params;
    return this.http.get<any>(`${API_PATH.apis.fetchReview}`, {
      params: params,
    });
  }

  sendUploadedReviewImageData(imageURL: string) {
    this.uploadReviewImageSubject.next(imageURL);
  }
  sendUploadedProfileImageData(imageURL: any) {
    this.uploadProfileImageSubject.next(imageURL);
  }

  sendLikeDislike(action: string, reviewDetails: ReveiwDetails) {
    if (localStorage.getItem("nVipaniwhiteshopkey")) {
      const data = localStorage.getItem("nVipaniwhiteshopUser");
      const requestObject: any = { userDetails: {} };
      // const user : UserDetails;
      if (userEmailCheck.test(data)) {
        requestObject.userDetails.email = data;
      } else if (userPhoneCheck.test(data)) {
        requestObject.userDetails.phone = data;
      }
      requestObject.userAction = action;
      requestObject.reviewId = reviewDetails.reviewId;
      return this.http.post<any>(
        `${API_PATH.apis.reviewLikeDislike}`,
        requestObject,
        httpOptions
      );
    } else {
      this.router.navigateByUrl("/signin");
    }
  }

  convertProdutDataToRequest(inputProduct?): ProductRequestToGetReviews {
    console.log("Entered ProductDataToRequest");

    const request: ProductRequestToGetReviews = { email: "", phone: "" };
    request.productId = { sequence: "", itemCode: "", batchNumber: "" };
    request.productId.sequence = inputProduct.productId.sequence;
    request.productId.itemCode = inputProduct.productId.itemCode;
    request.productId.batchNumber = inputProduct.productId.batchNumber;

    const userData = localStorage.getItem("nVipaniwhiteshopUser");
    if (userData && userData.includes(",")) {
      const values: string[] = userData.split(",");
      request.email = values[0];
      request.phone = values[1];
    } else if (userEmailCheck.test(userData)) {
      request.email = userData;
    } else if (userPhoneCheck.test(userData)) {
      request.phone = userData;
    }
    return request;
  }
  // fetchUserProfile(): Observable<UserDetails> {
  //     const sessionId: string = this.cookieService.get('SESSIONID');
  //     httpOptions.headers = httpOptions.headers.set('Authorization', sessionId);
  //     return this.http.get<UserDetails>(`${API_PATH.apis.getProfile}`, httpOptions);
  // }
}
